export const navLinks = [
  { label: "Producto", href: "#producto" },
  { label: "Precios", href: "#precios" },
  { label: "Integraciones", href: "#integraciones" },
  { label: "Dashboard", href: "#dashboard" },
];

export const problemStats = [
  { value: "67%", label: "de llamadas no atendidas nunca vuelven a llamar", icon: "ri-phone-off-line" },
  { value: "80%", label: "de reducción de costes frente a un call center tradicional", icon: "ri-bar-chart-line" },
  { value: "3 min", label: "de configuración para lanzar tu recepcionista IA", icon: "ri-timer-flash-line" },
  { value: "24/7", label: "disponibilidad total, sin festivos ni vacaciones", icon: "ri-time-line" },
];

export const features = [
  {
    icon: "ri-shield-check-line",
    title: "Disponibilidad Total 24/7/365",
    description: "Eliminación absoluta de llamadas perdidas. Tu recepcionista IA captura leads en el momento exacto de la intención de compra, incluso a las 3 de la madrugada.",
    metric: "0",
    metricLabel: "llamadas perdidas",
    color: "amber",
  },
  {
    icon: "ri-money-dollar-circle-line",
    title: "Reducción Radical de Costes",
    description: "Sustituye costes fijos por un modelo elástico. Reduce la carga operativa un 80% comparado con un call center tradicional sin sacrificar calidad.",
    metric: "80%",
    metricLabel: "ahorro operativo",
    color: "emerald",
  },
  {
    icon: "ri-global-line",
    title: "Capacidad Multilingüe Nativa",
    description: "Atención fluida en más de 31 idiomas con detección automática. Expansión global inmediata sin contratar personal nativo en cada mercado.",
    metric: "31",
    metricLabel: "idiomas nativos",
    color: "amber",
  },
];

export const testimonials = [
  {
    id: 1,
    name: "Dr. Alejandro Martínez",
    role: "Director Médico",
    company: "Clínica Salud Avanzada",
    avatar: "https://public.readdy.ai/ai/img_res/fc7213a085e698c440b4b000570bc2b8.jpg",
    quote: "Desde que implementamos VoiceAI, nunca hemos perdido una cita. El ROI fue visible en la primera semana. Nuestro equipo ahora puede centrarse en lo que realmente importa.",
    rating: 5,
    platform: "G2",
    metrics: "+240% en leads capturados",
  },
  {
    id: 2,
    name: "María González",
    role: "Socia Fundadora",
    company: "González & Asociados",
    avatar: "https://readdy.ai/api/search-image?query=professional%20female%20lawyer%20headshot%2C%20confident%20expression%2C%20office%20background%2C%20premium%20portrait%20photography%2C%20natural%20lighting%2C%20elegant%20appearance&width=80&height=80&seq=t2&orientation=squarish",
    quote: "En un despacho legal, cada llamada perdida es un cliente perdido. VoiceAI gestiona la primera toma de contacto con una precisión y profesionalidad que nos sorprendió.",
    rating: 5,
    platform: "Capterra",
    metrics: "0 llamadas perdidas en 6 meses",
  },
  {
    id: 3,
    name: "Carlos Ruiz",
    role: "CEO",
    company: "TechService Pro",
    avatar: "https://readdy.ai/api/search-image?query=professional%20male%20tech%20executive%20headshot%2C%20modern%20office%20background%2C%20business%20casual%2C%20contemporary%20portrait%20photography%2C%20confident%20leadership%20look&width=80&height=80&seq=t3&orientation=squarish",
    quote: "La integración con Google Calendar fue instantánea. Ahora el sistema agenda, reagenda y confirma citas autónomamente. Hemos reducido el staff de recepción en un 70%.",
    rating: 5,
    platform: "G2",
    metrics: "70% reducción en staff",
  },
  {
    id: 4,
    name: "Ana Fernández",
    role: "Directora de Operaciones",
    company: "Dental Excellence",
    avatar: "https://readdy.ai/api/search-image?query=professional%20female%20operations%20director%20headshot%2C%20modern%20dental%20clinic%20background%2C%20business%20attire%2C%20high%20quality%20portrait%2C%20warm%20approachable%20smile&width=80&height=80&seq=t4&orientation=squarish",
    quote: "Necesitábamos atención en catalán, castellano e inglés. VoiceAI lo detecta automáticamente y cambia de idioma sin ninguna fricción. Es magia tecnológica.",
    rating: 5,
    platform: "Capterra",
    metrics: "3 idiomas simultáneos",
  },
];

export const liveMetrics = [
  { value: "2.4M+", label: "Llamadas gestionadas este mes" },
  { value: "99.7%", label: "Uptime garantizado SLA" },
  { value: "14s", label: "Tiempo promedio de respuesta" },
  { value: "4.9/5", label: "Satisfacción media del usuario final" },
];

export const pricingPlans = [
  {
    id: "basico",
    name: "Básico",
    price: "199",
    period: "mes",
    description: "Ideal para pequeñas empresas que comienzan su digitalización",
    highlighted: false,
    cta: "Empezar Ahora",
    features: [
      { text: "500 minutos de voz al mes", included: true },
      { text: "Número de teléfono estándar", included: true },
      { text: "Integración Google Calendar básica", included: true },
      { text: "Seguridad estándar", included: true },
      { text: "Soporte por email 5×8", included: true },
      { text: "1 idioma configurado", included: true },
      { text: "PII Redaction Automática", included: false },
      { text: "Multi-Calendario Full", included: false },
      { text: "Cumplimiento HIPAA/Enterprise", included: false },
      { text: "FastMCP / CRM Custom", included: false },
    ],
  },
  {
    id: "profesional",
    name: "Profesional",
    price: "399",
    period: "mes",
    description: "El plan favorito de clínicas y despachos con alto volumen",
    highlighted: true,
    badge: "MÁS POPULAR",
    cta: "Empezar Ahora",
    features: [
      { text: "1.500 minutos de voz al mes", included: true },
      { text: "Verified Caller ID", included: true },
      { text: "Multi-Calendario Full", included: true },
      { text: "PII Redaction Automática", included: true },
      { text: "Soporte prioritario 24/7", included: true },
      { text: "Hasta 10 idiomas configurados", included: true },
      { text: "Canvas Memory (RAG en tiempo real)", included: true },
      { text: "Cumplimiento HIPAA/Enterprise", included: false },
      { text: "FastMCP / CRM Custom", included: false },
      { text: "Branded Call ID", included: false },
    ],
  },
  {
    id: "premium",
    name: "Premium",
    price: "799",
    period: "mes",
    description: "Para empresas enterprise con necesidades de máxima escala",
    highlighted: false,
    cta: "Empezar Ahora",
    features: [
      { text: "Minutos ilimitados", included: true },
      { text: "Branded Call ID Corporativo", included: true },
      { text: "FastMCP / CRM Custom", included: true },
      { text: "Cumplimiento HIPAA/Enterprise", included: true },
      { text: "Soporte dedicado SLA 99.9%", included: true },
      { text: "31 idiomas nativos completos", included: true },
      { text: "Canvas Memory (RAG en tiempo real)", included: true },
      { text: "API acceso completo", included: true },
      { text: "Onboarding personalizado", included: true },
      { text: "Infraestructura dedicada", included: true },
    ],
  },
];

export const integrations = [
  { name: "Google Calendar", icon: "ri-calendar-check-line", category: "Agenda" },
  { name: "Stripe", icon: "ri-bank-card-line", category: "Pagos" },
  { name: "HubSpot", icon: "ri-contacts-line", category: "CRM" },
  { name: "Salesforce", icon: "ri-cloud-line", category: "CRM" },
  { name: "Slack", icon: "ri-slack-line", category: "Comunicación" },
  { name: "Zapier", icon: "ri-flashlight-line", category: "Automatización" },
  { name: "Microsoft Teams", icon: "ri-team-line", category: "Comunicación" },
  { name: "Twilio", icon: "ri-phone-line", category: "Telefonía" },
  { name: "WhatsApp", icon: "ri-whatsapp-line", category: "Mensajería" },
  { name: "Zoho CRM", icon: "ri-briefcase-line", category: "CRM" },
  { name: "Notion", icon: "ri-file-list-line", category: "Productividad" },
  { name: "Webhooks API", icon: "ri-code-s-slash-line", category: "Desarrollo" },
];

export const securityFeatures = [
  { icon: "ri-shield-keyhole-line", title: "Cumplimiento HIPAA", desc: "Datos médicos protegidos bajo los más altos estándares internacionales" },
  { icon: "ri-lock-password-line", title: "PII Redaction Automática", desc: "Eliminación automática de datos personales sensibles en transcripciones" },
  { icon: "ri-server-line", title: "Infraestructura ISO 27001", desc: "Servidores certificados en Europa con cifrado AES-256 en reposo y tránsito" },
  { icon: "ri-eye-off-line", title: "Zero-Knowledge Architecture", desc: "Ni siquiera nuestro equipo puede acceder a las conversaciones de tus clientes" },
];

export const dashboardStats = [
  { label: "Llamadas Respondidas", value: "1,847", change: "+12%", icon: "ri-phone-fill", positive: true },
  { label: "Leads Capturados", value: "342", change: "+28%", icon: "ri-user-add-fill", positive: true },
  { label: "Citas Agendadas", value: "218", change: "+19%", icon: "ri-calendar-fill", positive: true },
  { label: "Coste por Lead", value: "4.20€", change: "-31%", icon: "ri-money-euro-circle-fill", positive: true },
];

export const recentCalls = [
  { time: "Hoy 14:32", caller: "+34 612 345 678", duration: "3:24", outcome: "Cita agendada", lang: "ES" },
  { time: "Hoy 13:15", caller: "+44 7700 900123", duration: "1:52", outcome: "Lead capturado", lang: "EN" },
  { time: "Hoy 11:48", caller: "+34 699 112 233", duration: "4:07", outcome: "Cita agendada", lang: "ES" },
  { time: "Hoy 10:23", caller: "+33 6 12 34 56 78", duration: "2:31", outcome: "Información enviada", lang: "FR" },
  { time: "Ayer 18:55", caller: "+34 608 765 432", duration: "1:15", outcome: "Transferencia VIP", lang: "ES" },
];

export const tbcspnLayers = [
  {
    id: "surface",
    label: "Surface Layer",
    sublabel: "Capa de Superficie",
    color: "amber",
    icon: "ri-user-star-line",
    role: "Centauric AI — Supervisión Humana",
    description: "El cliente define la dirección estratégica y valida las decisiones críticas del negocio. Control total sin complejidad técnica.",
    agents: ["Cliente / Operador", "Validación de Decisiones", "Panel de Control"],
  },
  {
    id: "observation",
    label: "Observation Layer",
    sublabel: "Capa de Observación",
    color: "stone",
    icon: "ri-search-eye-line",
    role: "planning_agent — Orquestación",
    description: "Refina los tópicos y orquesta la conversación analizando el historial completo antes de activar la capa de ejecución.",
    agents: ["planning_agent", "Análisis de Historial", "Topic Refinement"],
  },
  {
    id: "computation",
    label: "Computation Layer",
    sublabel: "Capa de Cómputo",
    color: "emerald",
    icon: "ri-cpu-line",
    role: "worker_agents — Ejecución",
    description: "Los agentes ejecutores realizan la llamada, procesan el lenguaje natural y ejecutan las APIs de calendario en tiempo real.",
    agents: ["interviewer_agent", "calendar_agent", "CRM API Connector"],
  },
];

export const techStack = [
  { category: "Frontend & Backend", icon: "ri-code-box-line", items: ["Next.js 14 (Server Components)", "TailwindCSS + shadcn/ui", "Neon PostgreSQL + Prisma ORM"] },
  { category: "Orquestación IA", icon: "ri-robot-line", items: ["AutoGen Multi-Agent Framework", "MCP (Model Context Protocol)", "TB-CSPN Process Networks"] },
  { category: "Memoria & RAG", icon: "ri-database-2-line", items: ["ChromaDB Semántica", "Memoria Episódica Contextual", "RAG en tiempo real"] },
  { category: "Voz & Telefonía", icon: "ri-phone-line", items: ["OpenAI Realtime API", "Twilio Media Streams", "WebSocket Bridge Modular"] },
];

export const voiceLatencySteps = [
  { step: "01", label: "Audio Input", desc: "Twilio captura el audio de la llamada entrante en tiempo real", icon: "ri-mic-line", ms: "0ms" },
  { step: "02", label: "Media Stream", desc: "Twilio Media Streams transmite el audio vía WebSocket al bridge", icon: "ri-broadcast-line", ms: "~50ms" },
  { step: "03", label: "Realtime API", desc: "OpenAI Realtime API procesa audio-a-audio de forma nativa", icon: "ri-brain-line", ms: "~200ms" },
  { step: "04", label: "LLM + Agents", desc: "planning_agent orquesta la respuesta con contexto RAG", icon: "ri-flashlight-line", ms: "~350ms" },
  { step: "05", label: "Audio Output", desc: "Respuesta sintetizada enviada al usuario final", icon: "ri-volume-up-line", ms: "&lt;1s total" },
];

export const callerIdFeatures = [
  { icon: "ri-shield-check-line", title: "Verified SHAKEN/STIR", desc: "Firma criptográfica que certifica la autenticidad del número ante las operadoras" },
  { icon: "ri-building-line", title: "Branded Caller ID", desc: "El nombre de tu empresa aparece en la pantalla del cliente, aumentando hasta un 40% la tasa de respuesta" },
  { icon: "ri-spam-2-line", title: "Anti-SPAM Engine", desc: "Sistema activo de reputación de números para prevenir el marcado como SPAM por las operadoras" },
];

export const securityProtocols = [
  { icon: "ri-token-swap-line", title: "Autenticación JWT", desc: "Tokens con expiración corta y refresh rotation para proteger cada sesión del dashboard" },
  { icon: "ri-eraser-line", title: "Motor PII Redaction", desc: "Identifica y elimina automáticamente nombres, DNIs, IBANs y datos sensibles de transcripciones antes de almacenarlos" },
  { icon: "ri-stethoscope-line", title: "HIPAA Compliant", desc: "Business Associate Agreement (BAA) disponible para clínicas y proveedores de salud en plan Premium" },
  { icon: "ri-file-shield-2-line", title: "RGPD / GDPR", desc: "Data residency en Europa (Frankfurt). Derecho al olvido automatizado. DPA firmado en el onboarding" },
];

export const learningCycle = [
  { phase: "Construir", icon: "ri-hammer-line", desc: "Canvas Memory define el conocimiento base del agente para tu negocio específico" },
  { phase: "Colaborar", icon: "ri-team-line", desc: "El agente gestiona llamadas reales y genera Memorias Episódicas de cada interacción" },
  { phase: "Evolucionar", icon: "ri-plant-line", desc: "Las llamadas exitosas validadas se transfieren automáticamente al RAG principal, mejorando el sistema continuamente" },
];

export const howItWorksSteps = [
  {
    number: "01",
    title: "El cliente llama",
    subtitle: "Llamada entrante detectada",
    description: "Tu número de teléfono corporativo redirige automáticamente a la IA. La llamada se responde al primer tono, sin esperas, cualquier día del año a cualquier hora.",
    icon: "ri-phone-incoming-line",
    details: [
      "Respuesta instantánea al primer tono",
      "Caller ID verificado y registrado",
      "Idioma detectado automáticamente",
      "Contexto del cliente cargado desde CRM",
    ],
    visual: "phone",
  },
  {
    number: "02",
    title: "La IA conversa y entiende",
    subtitle: "Procesamiento en tiempo real",
    description: "El agente conversa de forma natural, identifica la intención del cliente, consulta tu base de conocimiento en tiempo real y gestiona cualquier solicitud con precisión.",
    icon: "ri-robot-2-line",
    details: [
      "Comprensión semántica profunda",
      "Consulta al RAG de tu negocio",
      "Detección de urgencias y VIPs",
      "Latencia sub-segundo garantizada",
    ],
    visual: "ai",
  },
  {
    number: "03",
    title: "La cita queda agendada",
    subtitle: "Confirmación automática",
    description: "El agente consulta disponibilidad en tiempo real, propone el slot óptimo bajo ISO 8601, confirma la cita y envía recordatorio automático. Tú no tocas nada.",
    icon: "ri-calendar-check-2-line",
    details: [
      "Verificación de disponibilidad FastMCP",
      "Evento creado en Google Calendar",
      "SMS y email de confirmación",
      "Reagendado autónomo si hay conflicto",
    ],
    visual: "calendar",
  },
];

export const faqItems = [
  {
    id: "f1",
    category: "Tecnología",
    question: "¿Suena artificial o robótica la voz? ¿Los clientes se dan cuenta?",
    answer: "La naturalidad es nuestra prioridad técnica número uno. Utilizamos OpenAI Realtime API con síntesis de voz de última generación que logra una prosodia, ritmo y emoción prácticamente indistinguibles de una persona real. En nuestros tests A/B con más de 10.000 llamadas, el 94% de los usuarios finales no detectaron que hablaban con una IA. Los clientes Premium pueden elegir entre motores de voz adicionales como ElevenLabs para personalizar aún más el timbre y acento.",
  },
  {
    id: "f2",
    category: "Privacidad",
    question: "¿Qué pasa con los datos de mis clientes? ¿Son seguros?",
    answer: "La seguridad de los datos es nuestra piedra angular. Todos los datos se almacenan exclusivamente en servidores europeos (Frankfurt, EU-CENTRAL-1) con cifrado AES-256 en reposo y TLS 1.3 en tránsito. Nuestro motor de PII Redaction elimina automáticamente nombres, DNIs y datos sensibles de las transcripciones antes de almacenarlas. Somos HIPAA Compliant, RGPD/GDPR certificados y tenemos acreditación ISO 27001. Nunca vendemos ni compartimos datos con terceros.",
  },
  {
    id: "f3",
    category: "Configuración",
    question: "¿Cómo se configura? ¿Necesito conocimientos técnicos o un equipo de IT?",
    answer: "Zero técnica requerida. La configuración completa se realiza en menos de 3 minutos a través de nuestro panel de control visual. Solo necesitas: (1) conectar tu Google Calendar con un click, (2) escribir en el Canvas Memory lo que tu IA debe saber sobre tu negocio (horarios, servicios, precios), y (3) redirigir tu número de teléfono. No hay código, no hay APIs complejas, no hay manuales de 200 páginas. Si sabes usar WhatsApp, sabes configurar VoiceAI.",
  },
  {
    id: "f4",
    category: "Tecnología",
    question: "¿Qué pasa si la IA no sabe responder a una pregunta específica?",
    answer: "Cuando el agente detecta que no tiene suficiente contexto para responder con confianza, activa automáticamente el protocolo de escalado inteligente: transfiere la llamada a un miembro de tu equipo con un resumen contextual previo al traspaso. Tú defines las reglas: qué tipo de preguntas escalan, a qué número, en qué horario. Además, cada vez que esto ocurre, el sistema lo registra como una oportunidad de aprendizaje y te notifica para que puedas añadir esa información al Canvas Memory, mejorando el sistema continuamente.",
  },
  {
    id: "f5",
    category: "Compatibilidad",
    question: "¿Funciona con mi sector? ¿Es válido para clínicas, despachos legales o empresas técnicas?",
    answer: "VoiceAI está diseñado específicamente para sectores de alta demanda: clínicas médicas y dentales, despachos de abogados, consultorías, servicios técnicos y de mantenimiento, centros de formación y cualquier PYME con alto volumen de llamadas entrantes. Los planes Profesional y Premium incluyen configuraciones pre-entrenadas específicas para cada sector, incluyendo vocabulario especializado, protocolos de urgencias médicas y flujos de triaje jurídico.",
  },
  {
    id: "f6",
    category: "Negocio",
    question: "¿Puedo cancelar cuando quiera? ¿Hay contratos de permanencia?",
    answer: "Sin contratos. Sin permanencia. Sin letra pequeña. Puedes cancelar tu plan desde el dashboard en cualquier momento con un click y tu cuenta quedará activa hasta el final del periodo de facturación ya abonado. No hay penalizaciones, no hay llamadas de retención incómodas. Creemos que si nuestra plataforma no genera valor para tu negocio, no merecemos tu dinero.",
  },
  {
    id: "f7",
    category: "Implementación",
    question: "¿Cuánto tarda en estar operativa la IA desde que me registro?",
    answer: "En condiciones normales, tu recepcionista IA puede estar respondiendo llamadas reales en menos de 15 minutos desde el registro. El flujo es: registro → conectar Google Calendar (2 min) → escribir el Canvas Memory con la info de tu negocio (5-10 min) → configurar el desvío de llamadas desde tu operadora (2 min). Para clientes Premium con integraciones CRM personalizadas o flujos complejos, el onboarding dedicado tarda entre 24-48 horas con acompañamiento de nuestro equipo.",
  },
  {
    id: "f8",
    category: "Integraciones",
    question: "¿Se integra con mi sistema de gestión o CRM actual?",
    answer: "Sí, gracias al protocolo MCP (Model Context Protocol) podemos conectarnos con prácticamente cualquier sistema. Las integraciones nativas incluyen Google Calendar, HubSpot, Salesforce, Zoho CRM, Microsoft Teams, Slack y Zapier (que a su vez conecta con más de 5.000 aplicaciones). Para sistemas propietarios o ERPs específicos del sector, los planes Premium incluyen integraciones custom mediante nuestra API REST documentada.",
  },
];
